import { PageValues } from '@/types/models/pages';

export interface BackendPage {
    id?: number,
    title: string,
    slug: string,
    content: string,
    isPublished: boolean,
    isVisibleInMobile: boolean,
}

export const transformBackendPage = (backendPage: BackendPage): PageValues => {
    return {
        title: backendPage.title,
        slug: backendPage.slug,
        content: backendPage.content,
        published: backendPage.isPublished,
        visibleInMobile: backendPage.isVisibleInMobile,
    }
}

export const transformPage = (page: PageValues): BackendPage => {
    return {
        title: page.title,
        slug: page.slug,
        content: page.content,
        isPublished: page.published,
        isVisibleInMobile: page.visibleInMobile,
    }
}
